import { formatOrgDateTime } from '@/lib/utils/custom-date/custom-date';
import { buildCsv } from '@/lib/csv';
import { LunchRequest } from '../types/manage-lunch.types';
import { sortFoodRequests } from './food-requests-print';

/** The legacy food request export's columns (its `Note` column has no field on `LunchRequest`). */
const CSV_HEADERS = ['Request Time', 'Name', 'Unit', 'Menu'];

/** One day's food requests as CSV, grouped by unit (department) and then by name, like the legacy export. */
export const buildFoodRequestsCsv = (requests: LunchRequest[]): string => {
  const rows = sortFoodRequests(requests).map((request) => ({
    'Request Time': formatOrgDateTime(request.CreatedDate),
    Name: request.DisplayName,
    Unit: request.DepartmentName,
    Menu: request.MenuName,
  }));
  return buildCsv(CSV_HEADERS, rows);
};
